import { render } from "./HowToPage.vue?vue&type=template&id=e27b6b28&scoped=true"
import script from "./HowToPage.vue?vue&type=script&lang=js"
export * from "./HowToPage.vue?vue&type=script&lang=js"

import "./HowToPage.vue?vue&type=style&index=0&id=e27b6b28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27b6b28"]])

export default __exports__